export default {"src":"/_next/static/image/public/images/ic_video_arrow.dc80871622f622144ee4099e8fdecee1.svg","height":40,"width":40};